import { dataObjectsDeepEqual } from "./object";
export const dataArrayAssert = (itemOrItems) => itemOrItems ? (Array.isArray(itemOrItems) ? itemOrItems : [itemOrItems]) : [];
export const dataArrayChunk = (array, size) => {
    const src = [...array];
    const results = [];
    while (src.length) {
        results.push(src.splice(0, size));
    }
    return results;
};
export const dataArrayContainsArray = (arrMain, arrSub) => arrSub.every((el) => arrMain.includes(el));
export const dataArrayEqual = (a, b, deep = false) => {
    if (a.length !== b.length)
        return false;
    if (a.length + b.length === 0)
        return true;
    else {
        const aSorted = [...a].sort(dataArraySort);
        const bSorted = [...b].sort(dataArraySort);
        let i = aSorted.length;
        while (--i >= 0 &&
            (deep
                ? dataObjectsDeepEqual(aSorted[i], bSorted[i])
                : aSorted[i] === bSorted[i]))
            ;
        return i < 0;
    }
};
export const dataArrayFromMap = (map) => Array.from(map, ([_key, value]) => value);
export const dataArrayItemByIdGet = (id, data) => data.find((item) => item.id === id);
export const dataArrayOfIdAndData = (data) => [data.id, data];
export const dataArrayPushUnique = (array, value) => {
    const result = [...array];
    if (!result.includes(value)) {
        result.push(value);
    }
    return result;
};
export const dataArraySieve = (array) => array.filter((item) => !!item);
export const dataArraySort = (a, b) => a > b ? 1 : a < b ? -1 : 0;
export const dataArraySortByProp = (getProp) => (a, b) => dataArraySort(getProp(a), getProp(b));
export const dataArraySquash = (arrayOfArrays) => [].concat(...arrayOfArrays);
export const dataArrayUnique = (array) => array.filter((item, index) => array.indexOf(item) === index);
export const dataArrayAddOrRemove = (array, value) => {
    const result = [...array];
    const idx = result.findIndex((el) => el === value);
    idx !== -1 ? result.splice(idx, 1) : result.push(value);
    return result;
};
export const dataArrayToHashMap = (array, key) => array.reduce((acc, item) => {
    acc[item[key]] = item;
    return acc;
}, {});
export function dataArrayMove(arraySrc, fromIndex, toIndex) {
    const array = [...arraySrc];
    const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < array.length) {
        const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;
        const [item] = array.splice(fromIndex, 1);
        array.splice(endIndex, 0, item);
    }
    return array;
}
export function dataArrayShuffle(array) {
    let currentIndex = array.length;
    const newArray = [...array];
    while (currentIndex !== 0) {
        const randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [newArray[currentIndex], newArray[randomIndex]] = [
            newArray[randomIndex],
            newArray[currentIndex],
        ];
    }
    return newArray;
}
export function dataArrayHumanJoin(arr, separator) {
    if (arr.length === 0) {
        return "";
    }
    if (arr.length === 1) {
        return arr[0];
    }
    if (arr.length === 2) {
        return arr.join(` ${separator} `);
    }
    return arr.slice(0, -1).join(", ") + ` ${separator} ` + arr[arr.length - 1];
}
export function dataArraySortByReference(target, reference) {
    const weightMap = new Map(reference.map((value, index) => [value, index]));
    return [...target].sort((a, b) => {
        var _a, _b;
        const weightA = (_a = weightMap.get(a)) !== null && _a !== void 0 ? _a : Infinity;
        const weightB = (_b = weightMap.get(b)) !== null && _b !== void 0 ? _b : Infinity;
        return weightA - weightB;
    });
}
//# sourceMappingURL=array.js.map